const state = {
	/**
	 * 代理商分销
	 */
	// 提现成功，跳转到提现记录页面
	isFromWithdraw: false,
	// 是否跳转到帮助中心
	isToHelp: false
};
export default state;
